<template>
  <div class="steps-wrapper">
    <div class="steps">
      <div class="step-wrapper" v-for="(step, index) in items" :key="index" :class="{ completed: value + 1 > index }">
        <div class="step-bridge" v-if="index !== 0"></div>
        <div class="step" @click="changeStep(index)">
          <div class="step-text">
            {{ step }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    value: Number,
  },
  methods: {
    changeStep(step) {
      if (this.value + 1 > step) {
        this.$emit('input', step);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.steps-wrapper {
  display: flex;
  width: 100%;
  padding: 35px 0 25px 0;
  justify-content: center;
}
.steps {
  width: 75%;
  display: flex;
  justify-content: center;
}
.step-wrapper {
  display: flex;
  align-items: center;
  flex-grow: 1;

  &:first-of-type {
    flex-grow: 0;
  }
}
.step {
  width: 16px;
  height: 16px;
  background-color: #d8d8d8;
  border-radius: 50%;
  position: relative;
}
.step-bridge {
  flex-grow: 1;
  background-color: #d8d8d8;
  height: 2px;
}
.step-text {
  position: absolute;
  left: 50%;
  top: 20px;
  font-size: 14px;
  transform: translate(-50%, 0);
  color: #d8d8d8;
  white-space: nowrap;
}
.completed {
  .step {
    background-color: #2c70c1 !important;
    cursor: pointer;

    .step-text {
      color: #2c70c1;
    }
  }
  .step-bridge {
    background-color: #2c70c1 !important;
  }
}
@media only screen and (max-width: 600px) {
  .step-text {
    display: none;
  }
}
</style>

